import { Part } from "../../entities/Part";
import { IPartsRepository } from "../../repositories/IPartsRepository";

export class GetAllPartsUseCase
{
    constructor(
        private partsRepository: IPartsRepository
    ) {}
    
    async execute(): Promise<Part[]>
    {
        const allParts = this.partsRepository.fetchAll();

        return allParts;
    }
}